package com.essntl.features.profile.domain.di

import org.koin.core.annotation.ComponentScan
import org.koin.core.annotation.Module

@Module
@ComponentScan("com.essntl.features.profile.domain.use_case")
class ProfileUseCaseModule